<template>
  <div class="kanban-column">
    <div class="column-header d-flex align-items-center">
      <h5 :class="`badge-type bg-${cardTypeClass}`">
        {{ totalizer }}
      </h5>
      <h5>{{ stageName }}</h5>
    </div>
    <draggable
      :value="recruitments"
      group="recruitments"
      :class="`scrolled scroll-${skin} kanban-cards`"
      :move="canDragRecruitment"
      :disabled="hasMovingRecruitments"
      :data-stage-id="type"
      ref="kanbanCardContainer"
      @change="handleDragChange"
    >
      <b-card
        v-for="recruitment in recruitments"
        :key="recruitment.id"
        no-body
        :class="[
          `border-${cardTypeClass} kanban-card`,
          recruitment.is_overdue ? 'is-overdue-kanban' : '',
          isRecruitmentMoving(recruitment.id) ? 'kanban-card-moving' : '',
        ]"
      >
        <b-card-body class="d-flex flex-column">
          <div
            v-if="isRecruitmentMoving(recruitment.id)"
            class="kanban-card-spinner"
          >
            <b-spinner small variant="primary" />
          </div>
          <!-- <div class="d-flex justify-content-between align-items-center">
            <div class="lead-qtd">
              <span :class="`badge-type bg-${cardTypeClass}`">{{
                recruitment.id
              }}</span>
              <span class="ml-1 text-white"
                ><b>{{ cardType }}</b></span
              >
            </div>
            <div class="lead-time text-white">
              <feather-icon icon="ClockIcon" size="16" />
              <span class="mr-2"> 5d 0h</span>
              <span class="percentage">23,5%</span>
            </div>
          </div> -->
          <aside :class="`card-info bg-card-${skin}`">
            <div
              class="card-type d-flex align-items-center justify-content-between mb-1"
            >
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  :checked="leadsSelected.includes(recruitment.customer_id)"
                  @change="toggleSelect(recruitment.customer_id)"
                >
                </b-form-checkbox>
                <!-- <span :class="`badge-type bg-${cardTypeClass}`">{{
                  cardType
                }}</span> -->
              </div>
              <div class="d-flex align-items-center">
                <button
                  @click="
                    toggleFavorite(
                      recruitment.is_favorite,
                      recruitment.customer_id
                    )
                  "
                >
                  <img
                    :src="favoriteIcon(recruitment.is_favorite)"
                    alt="star"
                  />
                </button>
                <b-dropdown
                  variant="link"
                  no-caret
                  right
                  toggle-class="toggle-padding"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="20"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item
                    @click="goToLeadDetails(recruitment.customer_id)"
                    ><span class="align-middle ml-50"
                      >Ver perfil</span
                    ></b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="hasRoadshowScore(recruitment)"
                    @click="reviewScore(recruitment.customer_id)"
                    ><span class="align-middle ml-50"
                      >Revisar score do RoadShow</span
                    ></b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="type < finalApprovalId"
                    @click="changeStage(recruitment.customer_id)"
                  >
                    <span class="align-middle ml-50"> Mudar etapa </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-else-if="type == finalApprovalId"
                    @click="
                      convertToPn(
                        recruitment.customer_id,
                        recruitment.approval_date
                      )
                    "
                  >
                    <span class="align-middle ml-50"> Converter para PN </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="recruitment.has_resume"
                    @click="downloadResume(recruitment.customer_id)"
                    ><span class="align-middle ml-50"
                      >Ver currículo</span
                    ></b-dropdown-item
                  >
                  <b-dropdown-item @click="editTags(recruitment.customer_id)"
                    ><span class="align-middle ml-50"
                      >Adicionar tag</span
                    ></b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="type <= finalApprovalId"
                    @click="resendEmail(recruitment.id)"
                  >
                    <span
                      class="align-middle d-flex text-left ml-50"
                      v-if="stageName === 'Leads'"
                    >
                      Enviar email de <br />
                      Análise Comportamental
                    </span>
                    <span class="align-middle ml-50" v-else>
                      Reenviar email
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      type <= finalApprovalId &&
                      !isDisqualifiedStatus(recruitment.customer_status)
                    "
                    @click="
                      disqualify(recruitment.id, recruitment.customer.name)
                    "
                    ><span class="align-middle ml-50 text-danger"
                      >Desclassificar lead</span
                    ></b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>

            <div
              class="lead-info d-flex align-items-end justify-content-between mb-1"
            >
              <div class="lead d-flex flex-column">
                <span class="lead-name"
                  ><b>{{ recruitment.customer.name }}</b></span
                >
              </div>
            </div>

            <div
              class="lead-info d-flex align-items-end justify-content-between mb-1"
            >
              <div class="lead d-flex flex-column">
                <div
                  v-if="recruitment.customer.cell_phone"
                  class="d-flex align-items-center"
                >
                  <feather-icon icon="PhoneIcon" size="16" />
                  <span>{{
                    recruitment.customer.cell_phone | formatPhone
                  }}</span>
                </div>
                <div
                  v-if="recruitment.customer.address_state"
                  class="adress d-flex align-items-center"
                >
                  <feather-icon icon="MapPinIcon" size="16" />
                  <span :title="recruitment.customer.address_state">{{
                    recruitment.customer.address_state
                  }}</span>
                </div>
              </div>
              <div
                :id="`card-${recruitment.customer_id}`"
                :class="[
                  'time d-flex align-items-center',
                  recruitment.is_overdue ? 'text-danger' : '',
                ]"
              >
                <feather-icon icon="ClockIcon" size="16" />
                <span class="mr-2">
                  {{ recruitment.recruitment_stage_days }}</span
                >
              </div>
              <b-tooltip
                v-if="recruitment.is_overdue"
                triggers="hover"
                :target="`card-${recruitment.customer_id}`"
                :delay="{ show: 500, hide: 50 }"
              >
                <h4 class="text-danger font-weight-bold">
                  <feather-icon icon="AlertTriangleIcon" size="20" /> Atenção
                </h4>
                <p>
                  Prazo esgotado nesta etapa!<br />Atrasado por
                  {{ transformStageDays(recruitment.recruitment_stage_days) }}.
                </p>
              </b-tooltip>
            </div>

            <div
              v-if="recruitment.added_by_name"
              class="lead-source d-flex flex-column mb-1"
            >
              <small>Dono do Lead:</small>
              <span>{{ recruitment.added_by_name }}</span>
            </div>

            <div class="lead-status d-flex flex-column mb-1">
              <small>Status atual:</small>
              <b-badge
                :variant="badgeVariant(recruitment.customer_status)"
                pill
              >
                <feather-icon
                  v-if="recruitment.customer_status === 'A classificar'"
                  icon="ClockIcon"
                  size="10"
                />
                <img
                  v-else
                  :src="badgeIcon(recruitment.customer_status)"
                  width="12"
                />
                {{ recruitment.customer_status }}
              </b-badge>
            </div>

            <div
              v-if="recruitment.customer.source"
              class="lead-source d-flex flex-column mb-1"
            >
              <small>Fonte:</small>
              <span>{{ recruitment.customer.source | leadOrigin }}</span>
            </div>

            <div
              class="lead-data d-flex justify-content-between align-items-center mb-1"
            >
              <div
                class="d-flex flex-column"
                v-if="recruitment.next_appointment_date"
              >
                <small>Data do próximo compromisso:</small>
                <span>{{ formatDate(recruitment.next_appointment_date) }}</span>
              </div>
              <div class="d-flex flex-column" v-if="stageName === 'Road Show'">
                <small>Questionário já foi preenchido?</small>
                <span>{{
                  recruitment.roadshow_completed ? "Sim" : "Não"
                }}</span>
              </div>
            </div>

            <div
              v-if="stageName === 'Road Show' && hasRoadshowScore(recruitment)"
              class="lead-roadshow-score d-flex flex-column mb-1"
            >
              <small>Score do RoadShow:</small>
              <span class="roadshow-score-value">
                <b>{{ formatScore(recruitment.roadshow_score_total) }}</b> pts
              </span>
            </div>

            <div
              v-if="stageName === 'Entrevista Individual' && hasInterviewScore(recruitment)"
              class="lead-roadshow-score d-flex flex-column mb-1"
            >
              <small>Score da Entrevista Individual:</small>
              <span class="roadshow-score-value">
                <b>{{ formatScore(recruitment.interview_score_total) }}</b> pts
              </span>
            </div>

            <div class="lead-tags d-flex mb-1">
              <b-badge
                pill
                :variant="tagVariant(tag.name)"
                :class="isDesalinhamento(tag.name) ? 'tag-desalinhamento' : ''"
                v-for="(tag, index) in recruitment.customer.customer_tags"
                :key="index"
              >
                <feather-icon
                  v-if="isDesalinhamento(tag.name)"
                  icon="AlertOctagonIcon"
                  size="11"
                  class="mr-25"
                />
                <small>#{{ tag.name }}</small>
              </b-badge>
            </div>

            <div
              :class="`lead-icons d-flex justify-content-between align-items-center top-line-${skin}`"
            >
              <div class="contact-icons">
                <button
                  :id="`recruitment-kanban-whatsapp-${recruitment.id}`"
                  :class="`btn-icons whats-icon hover-${skin}`"
                  @click="openWhatsapp(recruitment.customer.cell_phone)"
                >
                  <img
                    class=""
                    src="~@/assets/images/svg/icn_whats.svg"
                    width="24"
                  />
                </button>
                <b-tooltip
                  :target="`recruitment-kanban-whatsapp-${recruitment.id}`"
                  placement="top"
                >
                  Enviar mensagem no WhatsApp
                </b-tooltip>
                <template v-if="stageName === 'Road Show'">
                  <button
                    :id="`recruitment-kanban-roadshow-${recruitment.id}`"
                    :class="`btn-icons hover-${skin}`"
                    @click="copyRoadshow(recruitment.customer_id)"
                  >
                    <feather-icon icon="CopyIcon" size="24" />
                  </button>
                  <b-tooltip
                    :target="`recruitment-kanban-roadshow-${recruitment.id}`"
                    placement="top"
                  >
                    Copiar mensagem do RoadShow
                  </b-tooltip>
                </template>
                <template v-if="stageName === 'Entrevista Individual'">
                  <button
                    :id="`recruitment-kanban-interview-${recruitment.id}`"
                    :class="`btn-icons hover-${skin}`"
                    @click="goToIndividualInterview(recruitment.customer_id)"
                  >
                    <feather-icon icon="FileTextIcon" size="24" />
                  </button>
                  <b-tooltip
                    :target="`recruitment-kanban-interview-${recruitment.id}`"
                    placement="top"
                  >
                    Abrir entrevista individual
                  </b-tooltip>
                </template>
                <button
                  :id="`recruitment-kanban-comment-${recruitment.id}`"
                  :class="`btn-icons hover-${skin}`"
                  @click="addComment(recruitment.customer_id)"
                >
                  <feather-icon icon="MessageSquareIcon" size="24" />
                </button>
                <b-tooltip
                  :target="`recruitment-kanban-comment-${recruitment.id}`"
                  placement="top"
                >
                  Adicionar comentário
                </b-tooltip>
              </div>
              <div class="status-icons">
                <template v-for="(iconStatus, index) in statusIcons">
                  <button
                    :key="index"
                    :id="`recruitment-kanban-${iconStatus}-${recruitment.id}`"
                    :class="`btn-icons hover-${skin}`"
                    @click="toggleStatus(recruitment.customer_id, iconStatus)"
                  >
                    <img
                      :src="
                        getStatusIcon(iconStatus, recruitment.customer_status)
                      "
                      width="24"
                    />
                  </button>
                  <b-tooltip
                    :target="`recruitment-kanban-${iconStatus}-${recruitment.id}`"
                    placement="top"
                  >
                    {{ getStatusName(iconStatus) }}
                  </b-tooltip>
                </template>
              </div>
            </div>
          </aside>
        </b-card-body>
      </b-card>
      <div
        v-if="hasMore"
        class="load-more-container w-100 d-flex justify-content-center mt-1"
      >
        <b-button variant="primary" @click="loadMore(type)"
          >Carregar mais</b-button
        >
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as types from "../store/types";
import * as sharedTypes from "@/modules/shared/store/types";
import { useToast } from "vue-toastification/composition";
import useAppConfig from "@core/app-config/useAppConfig";
import ToastificationContent from "@/@core/components/toastification/ToastificationContent";
import {
  FINAL_APPROVAL,
  INDIVIDUAL_INTERVIEW,
  ROAD_SHOW,
} from "@/constants/recruitment_stages";

export default {
  components: {
    draggable,
  },
  props: {
    stageName: {
      type: String,
      required: true,
    },
    recruitments: {
      type: Array,
      required: true,
    },
    cardType: {
      type: String,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
    totalizer: {
      type: Number,
      required: true,
    },
    search: {
      type: Function,
      default: () => {},
    },
  },
  setup() {
    const { skin } = useAppConfig();

    return { toast: useToast(), skin };
  },
  data() {
    return {
      statusIcons: ["hot", "cold", "disinterested"],
      roadShowUrl: process.env.VUE_APP_ROADSHOW_FRONTEND_URL,
      finalApprovalId: FINAL_APPROVAL.id,
    };
  },
  computed: {
    ...mapGetters({
      leadsSelected: types.LEADS_SELECTED,
      kanbanStages: types.RECRUTMENT_KANBAN,
      recruitmentMovingIds: types.RECRUITMENT_MOVING_IDS,
    }),
    cardTypeClass() {
      const typeMap = {
        1: "lead",
        2: "road-show",
        3: "group-dynamic",
        4: "individual-interview",
        5: "pre-job-sample",
        6: "job-sample",
        7: "final-approval",
        8: "converted-to-pn",
      };
      return typeMap[this.type] || "default";
    },
    hasMore() {
      return this.recruitments.length < this.totalizer;
    },
    hasMovingRecruitments() {
      return this.recruitmentMovingIds.length > 0;
    },
  },
  mounted() {
    const container = this.$refs.kanbanCardContainer?.$el;
    if (container) {
      const savedScroll = sessionStorage.getItem(
        `scrollPosition-stage-${this.type}`
      );
      if (savedScroll !== null) {
        container.scrollTop = parseInt(savedScroll, 10);
      }

      // Salva a posição sempre que houver scroll
      container.addEventListener("scroll", () => {
        sessionStorage.setItem(
          `scrollPosition-stage-${this.type}`,
          container.scrollTop
        );
      });
    }
  },
  methods: {
    ...mapActions({
      moveRecruitmentLeadsStage: types.MOVE_RECRUITMENT_LEADS_STAGE,
      openLeadTagSidebar: types.OPEN_LEAD_TAG_SIDEBAR,
      openRoadshowScoreReview: types.OPEN_ROADSHOW_SCORE_REVIEW_SIDEBAR,
      openCommentSidebar: sharedTypes.OPEN_COMMENT_SIDEBAR,
      saveComment: sharedTypes.SAVE_CUSTOMER_COMMENT,
      getRoadshowMessage: sharedTypes.GET_ROADSHOW_MESSAGE,
      resendStageEmail: types.RESEND_STAGE_EMAIL,
    }),
    ...mapMutations({
      toggleLeadSelection: types.TOGGLE_LEAD_SELECTION,
      mutateModalRecruitmentStage: types.MUTATE_MODAL_RECRUITMENT_STAGE,
      moveRecruitment: types.MOVE_RECRUITMENT,
      rollbackRecruitmentMove: types.ROLLBACK_RECRUITMENT_MOVE,
      startRecruitmentMove: types.START_RECRUITMENT_MOVE,
      finishRecruitmentMove: types.FINISH_RECRUITMENT_MOVE,
    }),
    isRecruitmentMoving(recruitmentId) {
      return this.recruitmentMovingIds.includes(recruitmentId);
    },
    canMoveToStage(recruitment, stage) {
      return (
        recruitment &&
        recruitment.recruitment_stage_id < stage &&
        stage <= this.finalApprovalId
      );
    },
    canDragRecruitment(event) {
      const recruitment = event?.draggedContext?.element;
      const targetStage = Number(event?.to?.dataset?.stageId || this.type);

      if (!recruitment) return false;

      return (
        !this.hasMovingRecruitments &&
        !this.isRecruitmentMoving(recruitment.id) &&
        this.canMoveToStage(recruitment, targetStage)
      );
    },
    async handleDragChange(event) {
      const added = event && event.added;
      if (!added) return;

      const recruitment = added.element;
      if (!this.canMoveToStage(recruitment, this.type)) {
        this.restoreDragDom();
        return;
      }

      const targetInsertIndex = 0;

      if (this.isRoadshowWithoutQuestionnaire(recruitment)) {
        const confirmed = await this.confirmRoadshowIncomplete(recruitment);
        if (!confirmed) {
          this.restoreDragDom();
          return;
        }
      }

      if (this.hasReproveImmediatelyTag(recruitment)) {
        const confirmation = [this.buildReproveImmediatelyConfirmation(recruitment)];
        const confirmed = await this.confirmReproveImmediatelyMove(confirmation);
        if (!confirmed) {
          this.restoreDragDom();
          return;
        }

        await this.moveRecruitmentToStage(recruitment, targetInsertIndex, [
          recruitment.id,
        ]);
        return;
      }

      await this.moveRecruitmentToStage(recruitment, targetInsertIndex);
    },
    buildMoveRollback(recruitment) {
      const fromStage = recruitment.recruitment_stage_id;
      const sourceStage = this.kanbanStages.find(
        (stage) => stage.stage_id === fromStage
      );

      if (!sourceStage) return null;

      const fromIndex = sourceStage.recruitments.findIndex(
        (item) => item.id === recruitment.id
      );

      return {
        recruitmentId: recruitment.id,
        fromStage,
        fromIndex: fromIndex >= 0 ? fromIndex : 0,
        toStage: this.type,
        recruitment: { ...recruitment },
      };
    },
    async moveRecruitmentToStage(
      recruitment,
      insertIndex,
      confirmedReproveImmediatelyIds = []
    ) {
      const rollback = this.buildMoveRollback(recruitment);
      if (!rollback) {
        this.restoreDragDom();
        return;
      }

      let shouldFinishMove = true;
      this.startRecruitmentMove(recruitment.id);
      this.moveRecruitment({
        recruitment,
        stage: this.type,
        fromStage: rollback.fromStage,
        insertIndex,
        updates: {
          is_overdue: 0,
          recruitment_stage_days: "0h",
        },
      });

      try {
        const response = await this.moveRecruitmentLeadsStage({
          recruitment,
          stage: this.type,
          confirmed_reprove_immediately_ids: confirmedReproveImmediatelyIds,
        });
        const data = response?.data || {};
        const moved = this.getMovedRecruitments(data, recruitment);

        if (!this.isStageMoveSuccessful(response, data)) {
          this.rollbackRecruitmentMove(rollback);
          this.showStageMoveWarning(data);
          return;
        }

        if (this.shouldOpenAppointmentSidebar(data)) {
          this.$emit("requires-appointment", moved);
        }
      } catch (error) {
        this.rollbackRecruitmentMove(rollback);

        const requiresConfirmation = this.getRequiresConfirmation(error);
        if (requiresConfirmation.length) {
          this.finishRecruitmentMove(recruitment.id);
          shouldFinishMove = false;
          const confirmed = await this.confirmReproveImmediatelyMove(
            requiresConfirmation
          );

          if (confirmed) {
            await this.moveRecruitmentToStage(
              { ...rollback.recruitment },
              insertIndex,
              requiresConfirmation.map((item) => item.id)
            );
          } else {
            this.restoreDragDom();
          }
          return;
        }

        this.showStageMoveError(error);
      } finally {
        if (shouldFinishMove) {
          this.finishRecruitmentMove(recruitment.id);
        }
      }
    },
    getMovedRecruitments(data, recruitment) {
      if (Array.isArray(data.moved) && data.moved.length) {
        return data.moved;
      }

      return [
        {
          id: recruitment.id,
          customer_id: recruitment.customer_id,
          name: recruitment.customer?.name,
          new_stage_id: this.type,
        },
      ];
    },
    isStageMoveSuccessful(response, data) {
      if (Array.isArray(data.moved)) {
        return data.moved.length > 0;
      }

      if (Number(data.summary?.moved || 0) > 0) {
        return true;
      }

      const blocked = data.blocked || [];
      const requiresConfirmation = data.requires_confirmation || [];
      if (blocked.length || requiresConfirmation.length) {
        return false;
      }

      return response?.status >= 200 && response.status < 300;
    },
    shouldOpenAppointmentSidebar(data) {
      return data.requires_appointment || this.type === INDIVIDUAL_INTERVIEW.id;
    },
    restoreDragDom() {
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    getRequiresConfirmation(error) {
      return (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.requires_confirmation
      ) || [];
    },
    isRoadshowWithoutQuestionnaire(recruitment) {
      return (
        recruitment?.recruitment_stage_id === ROAD_SHOW.id &&
        !recruitment.roadshow_completed
      );
    },
    async confirmRoadshowIncomplete(recruitment) {
      const name = recruitment?.customer?.name || `#${recruitment.id}`;
      const result = await this.$swal({
        title: "Questionário não preenchido",
        html: `O candidato(a) <strong>${name}</strong> ainda não respondeu o questionário do Road Show.<br><br>Deseja avançar assim mesmo?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Avançar mesmo assim",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      });
      return result.isConfirmed || result.value;
    },
    hasReproveImmediatelyTag(recruitment) {
      const tags = recruitment?.customer?.customer_tags || [];
      return tags.some(
        (tag) =>
          (tag.name || "").trim().toLowerCase() === "reprove imediatamente"
      );
    },
    buildReproveImmediatelyConfirmation(recruitment) {
      return {
        id: recruitment.id,
        customer_id: recruitment.customer_id,
        name: recruitment.customer?.name,
        customer_name: recruitment.customer?.name,
        reason: "reprove_immediately",
      };
    },
    async confirmReproveImmediatelyMove(requiresConfirmation) {
      const names = requiresConfirmation
        .map((item) => item.customer_name || item.name || `#${item.id}`)
        .join("<br>");

      const result = await this.$swal({
        title: "Confirmar movimentação de etapa do candidato(a)?",
        html: `Este candidato(a) possui a tag <strong>Reprove imediatamente</strong>.<br><br>${names}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar movimentação",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      });

      return result.isConfirmed || result.value;
    },
    showStageMoveWarning(data) {
      const blocked = data.blocked || [];
      const text =
        blocked[0]?.message ||
        "Nenhum lead foi movido. Atualize a lista e tente novamente.";

      this.toast({
        component: ToastificationContent,
        props: {
          title: "Atencao",
          text,
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    showStageMoveError(error) {
      const text =
        error?.response?.data?.message ||
        "Ocorreu um erro ao alterar a etapa. Entre em contato com o setor de TI.";

      this.toast({
        component: ToastificationContent,
        props: {
          title: "Oops!",
          text,
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
    },
    transformStageDays(stageDays) {
      const daysMatch = stageDays.match(/(\d+)d/);
      const hoursMatch = stageDays.match(/(\d+)h/);
      const days = daysMatch ? `${daysMatch[1]} dias e` : "";
      const hours = hoursMatch ? `${hoursMatch[1]} horas` : "";
      return `${days} ${hours}`.trim();
    },
    openWhatsapp(cell_phone) {
      setTimeout(() => {
        window.open("https://wa.me/" + cell_phone, "_blank").focus();
      });
    },
    goToLeadDetails(customer_id) {
      var routeData = this.$router.resolve({
        name: "lead-pn-profile",
        params: { id: customer_id },
      });
      setTimeout(() => {
        window.open(routeData.href, "_blank");
      });
    },
    badgeVariant(status) {
      const variantMap = {
        "A classificar": "undefined-user",
        Quente: "hot-user",
        Frio: "cold-user",
        Desinteressado: "disinterested-user",
        "Entrevista agendada": "scheduled_interview-user",
        "Entrevista feita": "done_interview-user",
        "Entrevista PN feita": "done_interview-lead-consultant",
        Suporte: "support-user",
        Básico: "basic_sub-user",
        Essencial: "essential_sub-user",
        Elite: "elite_sub-user",
        "Transformado em PN": "transformed-user",
        default: "default-user",
      };
      return variantMap[status] || "default-user";
    },
    badgeIcon(status) {
      const iconMap = {
        Quente: require("../../../assets/images/svg/icn_hot_active.svg"),
        Frio: require("../../../assets/images/svg/icn_cold_active.svg"),
        Desinteressado: require("../../../assets/images/svg/icn_disinterested_active.svg"),
        "Transformado em PN": require("../../../assets/images/svg/icn_converted_to_pn_active.svg"),
      };
      return iconMap[status] || "";
    },
    favoriteIcon(isFavorite) {
      return isFavorite
        ? require("../../../assets/images/svg/icn_star_active.svg")
        : require("../../../assets/images/svg/icn_star_inactive.svg");
    },
    getStatusIcon(iconStatus, customerStatus) {
      let statusLowerCase = customerStatus?.toLowerCase();
      if (statusLowerCase === "quente") {
        statusLowerCase = "hot";
      }
      if (statusLowerCase === "frio") {
        statusLowerCase = "cold";
      }
      if (statusLowerCase === "desinteressado") {
        statusLowerCase = "disinterested";
      }
      const suffix = statusLowerCase.includes(iconStatus)
        ? "active"
        : "disable";
      return require(`@/assets/images/svg/icn_${iconStatus}_${suffix}.svg`);
    },
    getStatusName(iconStatus) {
      const statusMap = {
        hot: "Esquentar",
        cold: "Esfriar",
        disinterested: "Desinteressado",
      };
      return statusMap[iconStatus] || "";
    },
    formatDate(dateString) {
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };
      const date = new Date(dateString);
      return date.toLocaleDateString("pt-BR", options).replace(",", " às");
    },
    toggleFavorite(favorite, id) {
      this.$emit("toggle-favorite", favorite, id);
    },
    toggleStatus(status, id) {
      this.$emit("toggle-status", id, status);
    },
    async loadMore(stageId) {
      this.$emit("load-more", stageId);

      await this.$nextTick();

      const container = this.$refs.kanbanCardContainer?.$el;
      if (container) {
        const savedScroll = sessionStorage.getItem(
          `scrollPosition-stage-${stageId}`
        );
        if (savedScroll !== null) {
          container.scrollTop = parseInt(savedScroll, 10);
        }
      }
    },
    toggleSelect(customer_id) {
      this.toggleLeadSelection(customer_id);
    },
    changeStage(customer_id) {
      this.mutateModalRecruitmentStage({ customer_id, visible: true });
    },
    editTags(customer_id) {
      this.openLeadTagSidebar({
        customer_id,
        saveAction: () => {
          this.search();
        },
      });
    },
    reviewScore(customer_id) {
      this.openRoadshowScoreReview({
        customer_id,
        saveAction: () => {
          this.search();
        },
      });
    },
    downloadResume(customer_id) {
      this.$emit("download-resume", customer_id);
    },
    disqualify(id, customer_name) {
      this.$emit("disqualify", id, customer_name);
    },
    isDisqualifiedStatus(status) {
      return status === "Desclassificado";
    },
    isDesalinhamento(tagName) {
      return tagName?.toLowerCase().includes("desalinhamento");
    },
    classificationTagVariant(tagName) {
      const normalized = (tagName || "").trim().toLowerCase();
      if (normalized === "alto potencial") return "success";
      if (normalized === "médio potencial" || normalized === "medio potencial")
        return "warning";
      if (normalized === "reprove imediatamente") return "danger";
      return null;
    },
    tagVariant(tagName) {
      if (this.isDesalinhamento(tagName)) return "danger";
      return this.classificationTagVariant(tagName) || "lead-tag";
    },
    hasRoadshowScore(recruitment) {
      return Boolean(recruitment.roadshow_classification);
    },
    hasInterviewScore(recruitment) {
      return Boolean(recruitment.interview_classification);
    },
    formatScore(value) {
      const number = Number(value);
      if (!Number.isFinite(number)) return "0";
      return Number.isInteger(number) ? String(number) : number.toFixed(1);
    },
    convertToPn(customer_id, approval_date) {
      this.$emit("convert-to-pn", customer_id, approval_date);
    },
    async saveLeadComment(payload) {
      return this.saveComment({
        customer_id: payload.id,
        comment: payload.comment,
      });
    },
    addComment(customer_id) {
      this.openCommentSidebar({
        id: customer_id,
        title: "Adicionar comentário",
        saveAction: this.saveLeadComment,
      });
    },
    async copyRoadshow(customer_id) {
      try {
        const response = await this.getRoadshowMessage(customer_id);
        await navigator.clipboard.writeText(response.data.message);
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Sucesso",
            text: "Mensagem e links do RoadShow copiados com sucesso.",
            icon: "CoffeeIcon",
            variant: "success",
          },
        });
      } catch ($e) {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao copiar o link.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    goToIndividualInterview(customer_id) {
      const routeData = this.$router.resolve({
        name: "individual-interview-report",
        params: { id: customer_id },
      });
      window.open(routeData.href, "_blank");
    },
    resendEmail(id) {
      this.resendStageEmail(id)
        .then(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Sucesso",
              text: "E-mail enviado com sucesso!",
              icon: "CoffeeIcon",
              variant: "success",
            },
          });
        })
        .catch((err) => {
          if (err.response.status == 405) {
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Oops!",
                text: err.response.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          } else {
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Oops!",
                text: "Ocorreu um erro ao enviar o e-mail. Entre em contato com o setor de TI.",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.kanban-column {
  display: flex;
  flex-direction: column;
  margin: 10px;
  min-width: 355px;

  .column-header {
    h5 {
      inline-size: max-content;
    }
    h5:first-child {
      margin-right: 0.5rem;
    }
  }
}

.kanban-cards {
  flex-grow: 1;
  min-height: 100px;
  max-height: 700px;
  overflow: auto;
}

.scrolled {
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 20px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #f26237;
    border-radius: 20px;
  }
}

.scroll-dark {
  &::-webkit-scrollbar-track {
    background: #181d2f;
  }
  &::-webkit-scrollbar-thumb {
    border: 3px solid #181d2f;
  }
}

.scroll-light {
  &::-webkit-scrollbar-track {
    background: #f8f8f8;
  }
  &::-webkit-scrollbar-thumb {
    border: 3px solid #f8f8f8;
  }
}

.card-header,
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* .card-body {
  margin: 10px 0;
} */

.card {
  min-width: 340px;
  margin-bottom: 1rem;
  border-radius: 10px;
  border: 1px solid #636363;
}

.kanban-card {
  position: relative;
}

.kanban-card-moving {
  cursor: wait;
  opacity: 0.72;

  .card-info {
    pointer-events: none;
  }
}

.kanban-card-spinner {
  position: absolute;
  right: 0.75rem;
  top: 0.75rem;
  z-index: 2;
}

.bg-lead {
  background-color: #3ba3f3;
}

.bg-road-show {
  background-color: #c62fc9;
}

.bg-group-dynamic {
  background-color: #f32f6d;
}

.bg-individual-interview {
  background-color: #f58240;
}

.bg-pre-job-sample {
  background-color: #775dd0;
}

.bg-job-sample {
  background-color: #546e7a;
}

.bg-final-approval {
  background-color: #26a69a;
}

.bg-converted-to-pn {
  background-color: #d10ce8;
}

.border-lead {
  border-left: 5px solid #3ba3f3;
}

.border-road-show {
  border-left: 5px solid #c62fc9;
}

.border-group-dynamic {
  border-left: 5px solid #f32f6d;
}

.border-individual-interview {
  border-left: 5px solid #f58240;
}

.border-pre-job-sample {
  border-left: 5px solid #775dd0;
}

.border-job-sample {
  border-left: 5px solid #546e7a;
}

.border-final-approval {
  border-left: 5px solid #26a69a;
}

.border-converted-to-pn {
  border-left: 5px solid #d10ce8;
}

.badge-type {
  width: min-content;
  padding: 3px 8px;
  border-radius: 10px;
  color: #ffffff;
  text-align: center;
  font-weight: bold;
  font-size: 1rem;
}

.lead-time {
  .percentage {
    font-size: 0.85rem;
  }
}

.lead-tags {
  width: 100%;
  flex-wrap: wrap;
  span {
    margin: 0.5rem 0.5rem 0 0;
  }
}

.tag-desalinhamento {
  box-shadow: 0 0 6px 2px rgba(228, 84, 85, 0.6);
  font-weight: bold;

  small {
    font-weight: bold;
  }
}

@keyframes pulse-danger {
  0%,
  100% {
    box-shadow: 0 0 6px 2px rgba(228, 84, 85, 0.6);
  }
  50% {
    box-shadow: 0 0 12px 4px rgba(228, 84, 85, 0.9);
  }
}

.is-overdue-kanban {
  border-top: 2px solid #e45455;
  border-right: 2px solid #e45455;
  border-bottom: 2px solid #e45455;
}

// .bg-card-dark {
//   background-color: #161d31;
// }

// .bg-card-light {
//   background-color: #f8f8f8;
// }

.card-info {
  border-radius: 0.428rem;

  .card-type {
    .custom-checkbox {
      margin-right: 0.5rem;
    }

    button {
      background: none;
      border: none;

      img {
        width: 25px;
        height: 25px;
      }
    }
  }
}

.lead-info {
  .lead,
  .time {
    svg {
      margin-right: 0.5rem;
    }
  }

  .lead {
    .lead-name {
      font-size: 1.25rem !important;
    }
  }

  .adress {
    span {
      max-width: 250px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }
}

.lead-status {
  small {
    margin-bottom: 0.5rem;
  }

  .badge {
    width: min-content;
  }
}

.lead-source {
  small {
    margin-bottom: 0.25rem;
  }
}

.top-line-dark {
  width: 100%;
  border-top: 1px solid #636363;
}

.top-line-light {
  width: 100%;
  border-top: 1px solid #f8f8f8;
}

.lead-icons {
  padding-top: 1rem;

  button {
    background: none;
    border: none;
    transition: all 0.3s ease;
    padding: 0.5rem;

    .feather {
      filter: brightness(0) saturate(100%) invert(81%) sepia(10%) saturate(136%)
        hue-rotate(182deg) brightness(89%) contrast(91%);
    }

    img,
    .feather {
      height: 24px;
    }
  }

  .whats-icon {
    img {
      filter: brightness(0) saturate(100%) invert(51%) sepia(70%)
        saturate(1070%) hue-rotate(81deg) brightness(107%) contrast(118%);
    }

    &:hover {
      background-color: rgba(13, 128, 29, 0.3) !important;
    }
  }

  .hover-dark:hover {
    background-color: rgba(248, 248, 248, 0.1);
    border-radius: 0.428rem;
  }

  .hover-light:hover {
    background-color: rgba(22, 29, 49, 0.1);
    border-radius: 0.428rem;
  }
}

</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.toggle-padding {
  padding: 0.786rem !important;
  padding-right: 0 !important;
}
</style>
